import PropTypes from 'prop-types';
import React from 'react';
import { TitleWrapper, Description, CareMenuSectionWrapper, CareMenu } from './CareMenuSection.style';
import Markdown from '../../../components/Markdown';

const CareMenuSection = ({ data }) => (
  <CareMenuSectionWrapper>
    {data.map(careMenu => (
      <CareMenu key={careMenu.entryId}>
        <TitleWrapper>{careMenu.title}</TitleWrapper>
        <Markdown src={careMenu.description} Component={Description} />
        <img src={careMenu.image.file.url} alt={careMenu.image.file.title} />
      </CareMenu>
    ))}
  </CareMenuSectionWrapper>
);

CareMenuSection.defaultProps = {
  data: [],
};
CareMenuSection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
};

export default CareMenuSection;



// WEBPACK FOOTER //
// ./src/pages/RangePage/CareMenuSection/CareMenuSection.js